<template>
  <div class="timespan-list" :style="cssVars">
    <ul class="nav-list">
      <li
        class="nav-tab"
        v-for="timeSpan in timeSpans"
        v-bind:class="{ active: timeSpan.active }"
        :key="timeSpan.span"
        @click="selectTimeSpan(timeSpan)"
      >
        {{ timeSpan.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import { defaultTimeSpans } from "../util/chart/defaultTimeSpans";
import { eventBus } from "../util/instances";

const getTimeSpans = () => defaultTimeSpans;
const emptyObject = function() {
  return {};
};

export default {
  name: "chart-control-timespan",
  props: {
    channel: {
      type: String,
      required: true,
      default: "1"
    },
    config: {
      type: Object,
      required: false,
      default: emptyObject
    },
    theme: {
      type: Object,
      required: false,
      default: emptyObject
    },
    selectedSpan: {
      type: String,
      required: false,
      default: () => getTimeSpans().find(span => span.active).span
    },
    timeSpans: {
      default: getTimeSpans,
      type: Array,
      required: false
    }
  },
  data() {
    return {};
  },
  methods: {
    clearAll() {
      this.timeSpans.forEach(timespan => (timespan.active = false));
    },
    selectTimeSpan(timespan) {
      this.clearAll();
      timespan.active = true;
      eventBus.$emit(`${this.channel}:changeTimeSpan`, timespan);
    },
    setInitialTimeSpan(label) {
      this.timeSpans.forEach(
        timespan => (timespan.active = timespan.label === label)
      );
    }
  },
  created() {
    this.setInitialTimeSpan(this.selectedSpan);
    const timeSpanFilterIsSet =
      "timeSpanFilter" in this.config && this.config.timeSpanFilter.length > 0;
    if (timeSpanFilterIsSet) {
      this.timeSpans = this.timeSpans.filter(tab =>
        this.config.timeSpanFilter.includes(tab.label)
      );
    }
  },
  watch: {
    selectedSpan(label) {
      const selectedTimeSpan = this.timeSpans.find(
        timespan => timespan.label === label
      );
      this.selectTimeSpan(selectedTimeSpan);
    }
  },
  computed: {
    cssVars() {
      const fb = "initial";
      return {
        "--bg-color": this.theme["bg-color"] || fb,
        "--bg-color-active": this.theme["bg-color-active"] || fb,
        "--text-color": this.theme["color"] || fb,
        "--text-color-active": this.theme["color-active"] || fb,
        "--border-radius": this.theme["border-radius"] || fb,
        "--padding": this.theme["padding"] || fb,
        "--margin": this.theme["margin"] || fb
      };
    }
  }
};
</script>

<style scoped>
.nav-tab {
  color: var(--text-color);
  background-color: var(--bg-color);
  border-radius: var(--border-radius);
  padding: var(--padding);
  margin: var(--margin);
  display: inline-block;
  cursor: pointer;
}
.active {
  background-color: var(--bg-color-active);
  color: var(--text-color-active);
}
.nav-list {
  padding: 0;
}
</style>
